import React, {useRef, useState} from 'react';
import AuthLayout from "../../layouts/AuthLayout";
import ButtonLong from "../../components/ButtonLong";
import TextInput from "../../components/TextInput";
import {Link, useSearchParams} from "react-router-dom";
import Captcha from "../../components/Captcha";
import {toast} from "react-toastify";
import {apollo} from "../../utils/apollo";
import {useMutation} from "react-query";
import {REQUEST_PASSWORD_RESET} from "../../utils/graphql";
import {useTranslation} from "react-i18next";

function ResetPassword() {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const isExpired = searchParams.get('expired') === 'true';
    const [email, setEmail] = useState(searchParams.get('email') || "");
    const recaptcha = useRef()

    const requestPasswordResetMutation = useMutation({
        mutationFn: async () => {
            const {data} = await apollo.mutate({
                mutation: REQUEST_PASSWORD_RESET,
                variables: {
                    input: {
                        email,
                    }
                },
            });
            return data?.requestPasswordReset;
        },
        onError: ((error) => {
            if (error.graphQLErrors) {
                error.graphQLErrors.map((item) => console.log(item));
            }
        }),
        onSuccess: async (data) => {
            if (data && data.message) {
                if (data.success) {
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setTimeout(() => {
                    window.location.href = process.env.REACT_APP_PAYD_URL + `/login`;
                }, 5000)
            } else {
                toast.error(t('auth.something_went_wrong'))
            }
        },
        onSettled: async () => {
            recaptcha?.current?.reset()
        }
    })

    const resetPasswordHandler = async (e) => {
        e.preventDefault();
        const captcha = recaptcha.current?.getValue();
        if (!captcha) {
            toast.error(t('auth.verify_recaptcha'))
            return;
        }
        requestPasswordResetMutation.mutate();
    }

    return (
        <AuthLayout title={t('auth.reset_password_title')}>
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
                    {isExpired && (
                        <div className="mb-6 rounded-md bg-amber-50 p-4 border border-amber-300">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm font-semibold text-amber-800">
                                        {t('auth.password_expired_title')}
                                    </h3>
                                    <p className="mt-1 text-sm text-amber-700">
                                        {t('auth.password_expired_banner')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    <form className="space-y-6" action="#" method="POST">
                        <TextInput label={t('auth.email_address')} get={email} set={setEmail} id="email" name="email" type="email"
                                   required={true}/>

                        <div className="flex">
                            <Captcha ref={recaptcha} />
                        </div>
                        <div>
                            <ButtonLong onClick={resetPasswordHandler}
                                        disabled={requestPasswordResetMutation.isLoading}>{t('auth.reset_button')}</ButtonLong>
                        </div>
                    </form>
                </div>

                <p className="mt-10 text-center text-sm text-gray-500">
                    {t('auth.not_a_member_yet')}{' '}
                    <Link to="/register" className="font-semibold leading-6 text-cyan-500 hover:text-cyan-500">
                        {t('auth.sign_up_here')}
                    </Link>
                </p>

                <p className="mt-2 text-center text-sm text-gray-500">
                    {t('auth.already_signed_up')}{' '}
                    <Link to="/login" className="font-semibold leading-6 text-cyan-500 hover:text-cyan-500">
                        {t('auth.go_to_login')}
                    </Link>
                </p>
            </div>
        </AuthLayout>
    );
}

export default ResetPassword;
